import reducer from './reducer'

import * as facilityReversesOperations from './operations'
import * as facilityReversesSelectors from './selectors'

export { facilityReversesOperations, facilityReversesSelectors }

export default reducer
